<template>
  <div class="content">
    <div class="container-fluid">
      <router-view />
      <vue-progress-bar></vue-progress-bar>
    </div>
  </div>
</template>
<script>
import { getStorageData } from "@/utils/storage";

export default {
  mounted() {
    if (this.$hj) {
      const user = getStorageData("user");
      const identify = {
        id: user.uuid,
        email: user.email,
        fullName: user.fullName
      };

      this.$hj('identify', identify.id, identify);
    }
  },
};
</script>
<style>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.15s;
}

.fade-enter,
  .fade-leave-to
    /* .fade-leave-active in <2.1.8 */

 {
  opacity: 0;
}
</style>
